import React from "react";
import styled from "styled-components";

import { ContentWrapper, H2, GreyBg, Button, CenterBlock } from "../assets/styles/base";
import { colors } from "../constants/colors";
import { urls, extendUrlWithSourceVersion } from "../constants/urls";
import { breakpoints } from "../constants/breakpoints";
import InfoIcon from "../assets/icons/info.svg";
import ExpandIcon from "../assets/icons/expand.svg";
import BubblesIcon from "../assets/icons/bubbles.svg";
import DocsIcon from "../assets/icons/docs.svg";

const HowDoesItWork = ({ hasGreyBg, hasMarginTop }) => {
    const Content = (
        <StyledContentWrapper hasMarginTop={hasMarginTop}>
            <H2 center>Wie funktioniert miracl</H2>
            <ul>
                <li>
                    <IconBubble>
                        <DocsIcon />
                    </IconBubble>
                    <h3>1. Anfrage</h3>
                    <p>Checke deinen Finanzierungswunsch unverbindlich & kostenlos.</p>
                </li>
                <li>
                    <IconBubble>
                        <BubblesIcon />
                    </IconBubble>
                    <h3>2. Beratung</h3>
                    <p>Besprich deine Wünsche mit unseren erfahrenen Finanzierungsspezialist:innen.</p>
                </li>
                <li>
                    <IconBubble>
                        <InfoIcon />
                    </IconBubble>
                    <h3>3. Vergleich</h3>
                    <p>Wir vergleichen verschiedene Banken und holen dir die besten Angebote ein.</p>
                </li>
                <li>
                    <IconBubble>
                        <ExpandIcon />
                    </IconBubble>
                    <h3>4. Kreditzusage</h3>
                    <p>Erhalte durch miracl Top-Konditionen und eine superschnelle Zusage.</p>
                </li>
            </ul>
            <CenterBlock>
                <a href={extendUrlWithSourceVersion(urls.survey)}>
                    <Button>Zum Angebot</Button>
                </a>
            </CenterBlock>
        </StyledContentWrapper>
    );
    if (hasGreyBg) return <GreyBg>{Content}</GreyBg>;
    return Content;
};

const StyledContentWrapper = styled(ContentWrapper)`
    color: ${colors.primary};

    @media (min-width: ${breakpoints.tabletBigMin}) {
        margin-top: ${({ hasMarginTop }) => (hasMarginTop ? "100px" : "0")};
    }

    p {
        margin: 0;
    }
    ul {
        color: #17120f;
        display: flex;
        flex-flow: row wrap;
        list-style: none;
        margin: 40px 0;
        padding: 0;
        width: 100%;
        text-align: center;
    }
    li {
        box-sizing: border-box;
        margin-bottom: 40px;
        width: 100%;

        &:last-child {
            margin-bottom: 0;
        }
    }
    @media (min-width: 550px) {
        ul {
            margin-bottom: 20px;
        }
        li {
            padding: 0 15px;
            width: 50%;
        }
    }
    @media (min-width: ${breakpoints.desktopMin}) {
        li {
            width: 25%;
        }
    }
`;

const IconBubble = styled.div`
    align-items: center;
    background: #f8f8f8;
    border-radius: 50%;
    display: flex;
    height: 62px;
    justify-content: center;
    margin: 0 auto 15px;
    width: 62px;
`;

export default HowDoesItWork;
